/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'AddToListButton.cancel',
    defaultMessage: 'Cancel'
  },
  submit: {
    id: 'AddToListButton.submit',
    defaultMessage: 'Save'
  },
  label: {
    id: 'AddToListButton.label',
    defaultMessage: 'Add to List'
  },
  title: {
    id: 'AddToListButton.title',
    defaultMessage: 'Save Cart Items'
  },
  description: {
    id: 'AddToListButton.description',
    defaultMessage:
      'Please select the list you wish to save selected parts to or enter a new list name.'
  },
  caveat: {
    id: 'AddToListButton.caveat',
    defaultMessage:
      'Note: When adding to an existing list, any parts that already exist in the list will not be added.'
  },
  createNewSelectLabel: {
    id: 'AddToListButton.select.createNew',
    defaultMessage: 'Create "{name}"'
  },
  createNewSelectPlaceholder: {
    id: 'AddToListButton.select.placeholder',
    defaultMessage: 'Select or create a list'
  },
  successDuplicatesIgnored: {
    id: 'AddToListButton.select.success.duplicatesIgnored',
    defaultMessage:
      '{duplicates} {quantity, plural, one {is} other {are} } already in your list and were not re-added'
  },
  success: {
    id: 'AddToListButton.select.success',
    defaultMessage:
      '{quantity} {quantity, plural, =0 {items} one {item} other {items} } successfully saved to "{listName}".'
  },
  error: {
    id: 'AddToListButton.select.error',
    defaultMessage:
      'We were unable to save the {quantity, plural, one {item} other {items} } to "{listName}". Please try again later.'
  },
  duplicateError: {
    id: 'AddToListButton.select.error.duplicate',
    defaultMessage:
      'The selected {quantity, plural, one {item is} other {items are} } already in "{listName}".'
  }
});
